<template>
    <div id="container" type="vdpp" data-nosnippet>
        <div class="page page-dpp" :data-status="dpp.houseRealStatus" :data-catephoto="getCategories.length > 2"  v-ga:page="{pageType:'vdpp', glb: glb, state: dpp}" v-ga:request="{pageType:'vdpp', state: dpp}" v-nhs:listingviewed v-nhs:request>
            <mvtHeader :searchInput="searchInput" :geoInfo="dpp.geo" ></mvtHeader>
            <div class="dpp-layout">
                <div class="dpp-nav">
                    <dppNav class="left"></dppNav>
                    <dppButton></dppButton>
                </div>
                <dppPhotoNav v-if="getCategories.length > 2"></dppPhotoNav>
                <div class="dpp-photo-main">
                    <propertyTags class="dpp-photo-label"/>
                    <dppPhoto ref="dppPhoto" data-role="scroller"/>
                </div>
                <PropertySchema :data="dpp" :enableRealEstateSchema="isForSaleActive" :enableSingleFamilySchema="isForSaleActive" />
                <propertySummaryTitle v-if="getSplit('movoto-CW-3392')"/>
                <dppTitle v-else ref="dppTitle"/>
                <ul class="dpp-title dpp-title-sub" v-if="!getSplit('movoto-CW-3392')">
                    <template v-if="dpp.isRentals">
                        <li class="singleline" v-if="dpp.affordMonthPay && dpp.affordTotal">
                            <a class="link"  v-scroll="'nearbyAffordPanel'" role="button" comp="dppRentalTobuy">
                                <span>See homes to buy for under</span> <span class="text-safe">{{$filters.formatPrice(dpp.affordMonthPay)}}/Mo</span>
                            </a>
                        </li>
                        <li class="singleline">
                            <a id="checkrentalCredit" role="button" class="link" @click="show3rdPartyForm1('checkrentalCredit','rentalCredit','')" rel="nofollow noreferrer" target="_blank"> {{ getCreditMonitoringText }} </a>
                        </li>
                    </template>
                    <template v-else>
                        <template v-if="showFirmUnderTitle">
                            <li v-if="dpp.isActive">Listed by {{listOffice}}</li>
                            <li v-else-if="dpp.isSold">Listed by {{listOffice}}{{buyingOffice ? `, Bought with ${buyingOffice}` : '' }}</li>
                        </template>
                        <li class="singleline" v-else-if="getSplit('movoto-calcpayment-cw-12068')">
                            <button type="button" class="link" @click="show3way()">
                                Do You Qualify for Low Money Down? Check FHA Eligibility
                            </button>
                        </li>
                        <li class="singleline" v-else-if="showVeteransDrawLink">
                            <span role="button" v-ga:clickable="'veteransATFform'" @click="openVeteransHotlead({leadType : 'VeteranDPPSection'})" class="link">Veterans: Find an agent familiar with $0 down VA loans</span>
                        </li>
                        <li class="singleline" v-if="glb.transactionCount > 10">
                            {{glb.transactionCount}} homes bought nearby with <span @click="showTransDialog" class="underdash" role="button">Movoto</span> recently
                        </li>
                        <li class="singleline" v-else-if="glb.agentCount > 5">
                            <span @click="showTransDialog" class="underdash" role="button">Movoto</span> is helping {{glb.agentCount}} homebuyers near you
                        </li>
                        <li class="singleline" v-else>
                            Learn about {{glb.geo.city}}'s top <span @click="showTransDialog" class="underdash"  role="button">local Real Estate agents</span>
                        </li>
                    </template>
                </ul>
                <div class="dpp-aside">
                    <dppHotleadButton :assignedAgent="glb.agent" />
                </div>
                <dppBar/>
                <aside class="dpp-detail">
                    <section id="propertyDetailPanel">
                        <template v-if="getSplit('movoto-CW-3392')">
                            <h2 id="propertyDetailTitle" class="f4 m-b-2 text-bold singleline">About {{ dpp.geo.address }}</h2>
                            <propertySummaryDetails></propertySummaryDetails>
                        </template>
                        <template v-else>
                            <propertyBaserecordRental v-if="dpp.isRentals" />
                            <propertyBaserecord v-else />
                        </template>
                    </section>
                    <propertyOpenhouse v-if="dpp.isActive && !dpp.isRentals" id="openHousePanel" ref="openHouse"/>
                    <propertyDesc id="propertyDescriptionPanel" v-if="dpp.description"/>
                    <propertyMls v-if="dpp.mlsDbNumber && (!dpp.showAsPR || dpp.isRentals)" :buyingOffice="buyingOffice"/>
                    <section>
                        <h2 class="f3 text-bold">Additional property details</h2>
                        <propertyFeature v-if="dpp.features && dpp.features.length && !hideAllPropertyDetails"></propertyFeature>
                    </section>
                    <dppBanner v-if="!dpp.isRentals && dpp.isActive"/>
                    <dppKeyInsights id="keyInsightPanel" v-if="!dpp.hideKeyInsights && !dpp.isRentals" :compareData="getOjoMetricsComputingData" />
                    <section id="mvtSellPanel" v-if="!dpp.isActive && !dpp.isRentals"  comp="mvtSellPanel" v-ga:impression="'sell-banner'">
                        <div class="inline large bg-brand corner text-bold">
                            <div class="middle large center grid xs-grid-cols-1">
                                <h2 id="sellPanelBanner" class="text-center text-bold f3">Selling? Get a Cash Offer</h2>
                                <div class="grid xs-grid-cols-1 f6">
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; Sell your home quickly</div>
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; Enables you to buy before selling</div>
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; No staging or preparation needed</div>
                                </div>
                                <button id="sellPanelCta" type="button" class="btn secondary regular no-stroke"  @click="sendCashOffer">Get a Cash Offer</button>
                            </div>
                        </div>
                    </section>
                    <propertyStaticMap></propertyStaticMap>
                    <section id="propertyCommutePanel" v-if="componentMounted && !dpp.isRentals">
                        <h2 class="f4 text-bold singleline">{{molang('dpp.propertyCommute.commute')}}</h2>
                        <propertyCommute/>
                    </section>
                    <section v-if="componentMounted && dpp.isActive && !dpp.isRentals">
                        <mvtHotleadForm :options="dppScheduleOpt" />
                    </section>
                    <dppSchedule v-show="componentMounted && (!dpp.isActive || dpp.isRentals) && !dpp.showAsPR" id="propertySchedulePanel" ref="viewSchedule" :assignedAgent="glb.agent" ></dppSchedule>
                    <section id="mvtSellPanel" v-if="dpp.isActive && !dpp.isRentals"  comp="mvtSellPanel" v-ga:impression="'sell-banner'">
                        <div class="inline large bg-brand corner text-bold">
                            <div class="middle large center grid xs-grid-cols-1 text-bold">
                                <h2 id="sellPanelBanner" class="text-center text-bold f3">Selling? Get a Cash Offer</h2>
                                <div class="grid xs-grid-cols-1 f6">
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; Sell your home quickly</div>
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; Enables you to buy before selling</div>
                                    <div class="flex middle left"><i class="text-main-l1 icon-check-circle-outside f3"></i> &nbsp; No staging or preparation needed</div>
                                </div>
                                <button id="sellPanelCta" type="button" class="btn secondary regular no-stroke"  @click="sendCashOffer">Get a Cash Offer</button>
                            </div>
                        </div>
                    </section>
                    <propertyNearByHouse  v-if="dpp.isPrOnly && !dpp.isRentals" :title="'Nearby Similar Homes'" id="propertyNearbyHomePanel" carousalType="similar_homes" />
                    <propertyMortgage v-if="componentMounted && !dpp.isRentals" id="propertyMortgagePanel"/>
                    <propertyEstimate v-if="!dpp.isRentals" id="propertyEstimatePanel" :isMarket5YLoaded="isMarket5YLoaded" />
                    <propertySaleProceeds id="propertySaleProceedsPanel" v-if="!dpp.isActive && !dpp.isRentals"/>
                    <propertyHistory id="propertyPriceHistoryPanel" />
                    <propertyMarket id="propertyMarketPanel" v-if="!dpp.hideMarketStatistics && !dpp.isRentals" :fields="fields" :isMarket5YLoaded="isMarket5YLoaded"/>
                    <section id="propertyVeteransPanel" v-if="showVeteran && !dpp.isRentals">
                        <mvtCollapse :disable="disableCollapse">
                            <template v-slot:header="collapsible">
                                <h2 class="f4 text-bold singleline">{{molang('dpp.dppVeterans.veteransTitle')}}</h2>
                                <div class="f7 text-gray singleline" v-show="collapsible.collapsed"> {{molang('dpp.dppVeterans.veteransSub')}}</div>
                            </template>
                            <template v-slot:default>
                                <div class="grid xs-grid-cols-1">
                                    <div>Work with a Veterans specialist for expert guidance, and access the exclusive homebuying benefits for those that have served. Find a Veterans real estate agent or VA loan officer today.</div>
                                </div>
                                <div class="grid xs-grid-cols-1 m-t-2">
                                    <button type="button" v-ga:clickable="'veterandropdrawerREform'" class="btn primary regular" @click="openVeteransHotlead" >Meet a Veterans Real Estate Agent</button>
                                    <button type="button" v-if="getSplit('movoto-va-CW-4020')" class="btn secondary regular" @click="show3rdPartyForm({id:'veteransdrawer', url: 'veteransdrawer', cta: vaLoanCTA})" >{{ vaLoanCTA }}</button>
                                </div>
                            </template>
                        </mvtCollapse>
                    </section>
                    <section id="propertyInternetProvider" v-if="dpp.isRentals">
                        <mvtCollapse :disable="disableCollapse">
                            <template v-slot:header="collapsible">
                                <h2 class="f4 text-bold singleline">Internet and cable providers</h2>
                            </template>
                            <template v-slot:default>
                                <internetcableProvider :zipcode="dpp.geo.zipcode" :state="dpp.geo.stateCode" :city="dpp.geo.city"/>
                            </template>
                        </mvtCollapse>
                    </section>
                    <section id="rentalServices" v-if="dpp.isRentals">
                        <mvtCollapse >
                            <template v-slot:header="collapsible">
                                <h2 class="f4 text-bold singleline">{{molang('dpp.propertyMortgage.rentalServices')}}</h2>
                            </template>
                            <additionalServices :zipcode="dpp.geo.zipcode" :state="dpp.geo.state" :city="dpp.geo.city" :price="dpp.price"  :propertyType="dpp.propertyType" :yearBuilt="dpp.yearBuilt" />
                        </mvtCollapse>
                    </section>
                    <propertyInlineHotlead v-if="componentMounted" id="dppInlineHotlead" :assignedAgent="glb.agent" />
                    <dppNearbyAfford id="nearbyAffordPanel" v-if="dpp.isRentals"></dppNearbyAfford>
                    <propertyNearByHouse v-if="dpp.isRentals" id="propertyNearbyHomePanel" title="Nearby Rentals" />
                    <propertyNearByHouse v-if="!dpp.isPrOnly && !dpp.isRentals" :title="molang('dpp.propertyNearby.nearby')" id="propertyNearbyHomePanel" carousalType="nearby" />
                    <propertyNearByHouse v-if="!dpp.isRentals" :title="molang('dpp.bestValueHomes')" :sort="'pricepersqft_asc'" carousalType="best_value" />
                    <propertyNearByCity v-if="!dpp.isRentals" />
                    <section id="faqPanel" v-if="dpp.faqs && !dpp.isRentals">
                        <h2 class="f4 text-bold">Frequently Asked Questions</h2>
                        <mvtFaq :data="dpp.faqs" :attrDataNoSnippet="true"/>
                    </section>
                    <propertySeoLink id="propertySeoPanel"/>
                    <mvtFooter id="footer" :geoInfo="dpp.geo" :theme="'small'"/>
                </aside>
            </div>
            <template v-if="popPhotoLoaded">
                <propertyPopPhotoSingle ref="popPhotoSingle" :popPhotoIndex="popPhotoIndex" :popPhotoCateIndex="popPhotoCateIndex"></propertyPopPhotoSingle>
            </template>
            <template v-if="pop3dLoaded">
                <propertyPop3d ref="pop3d" :pop3dUrl="pop3dUrl"></propertyPop3d>
            </template>
            <template v-if="popMapLoaded">
                <propertyPopMap ref="popMap" :popMapTypeId="popMapTypeId" :popStreetView="popStreetView" :popFilter="popFilter" :popActiveMarker="popActiveMarker"></propertyPopMap>
            </template>
            <div v-if="!agentLoading" class="dpp-pop-chat" :class="{'show': activeChat}">
                <div class="dpp-pop-chat-msg p-x-0 p-y-0 corner">
                    <div class="p-x-3 p-y-3 text-bold">
                        <div @click="openChatPop">
                            <div v-if="assignedAgent && assignedAgent.firstName">
                                <div class="f7 m-b-1">Your agent, {{ assignedAgent.firstName }} says</div>
                                <div>Hey there! Let me know if you have any questions about this property.</div>
                            </div>
                            <div v-else>An experienced real estate agent wants to speak to you about {{ !dpp.isActive ? 'selling' :'' }} this property right now!</div>
                        </div>
                    </div>
                    <button type="button" aria-label="Dismiss message" @click="closeChat"><i class="icon-times"></i></button>
                </div>
                <img v-if="assignedAgent && assignedAgent.photoUrl" :title="assignedAgent.fullName" @click="openChatPop" class="circle default" alt="Agent Avatar" :src="assignedAgent.photoUrl" />
                <button v-else type="button" aria-label="Connect with a local real estate agent" @click="openChatPop" class="circle default"><i class="icon-user-home f3"></i></button>
            </div>
        </div>
        <template v-if="componentMounted">
            <mvtFeed :property="dpp"></mvtFeed>
            <mvtPopSignin />
            <mvtDialog ref="dppTransPop" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                    <div class="f4 text-center text-bold">Top local Real Estate agents</div>
                    <div>Match with experienced, local real estate agents from the most trusted brokerages near you, including Coldwell Banker, Keller Williams, Compass, Better Homes and Gardens, EXP, Century 21, RE/MAX, and more</div>
                    <ul class="grid xs-grid-cols-2 text-center"><li><i class="icon-hand-care f3"></i> <p>Carefully Vetted </p> <p>Professionals</p></li> <li><i class="icon-statistics-report f3"></i> <p class="f7">Experienced</p> <p class="f7">Negotiators</p></li> <li><i class="icon-user-check f3"></i> <p class="f7">Local Market</p> <p class="f7">Real Estate Experts</p></li> <li><i class="icon-shield-star f3"></i> <p class="f7">25,000+</p> <p class="f7">Top-Rated Agents</p></li> <li><i class="icon-doc f3"></i> <p class="f7">3+ Years in</p> <p class="f7">the Industry</p></li> <li><i class="icon-map-pin-home f3"></i> <p class="f7">Nationwide</p> <p class="f7">Representation</p></li></ul>
                </div>
            </mvtDialog>
            <mvtDialog ref="dppAvmDisclaimer3" v-ga:dialog class="home-value-test">
                <div class="grid xs-grid-cols-1">
                    <div class="dialog-profile">
                        <div class="circle huge default"><img loading="lazy" :src=" glb.cdnUrl + 'vimages/avm-img.svg'"/></div>
                    </div>
                    <div class="f4 text-bold text-center">Rental Estimate</div>
                    <div>We determine the rental value of this property by conducting a comparative analysis with similar homes for rent in the nearby area. Our assessment considers essential data points, such as location, square footage, number of bedrooms and bathrooms, and other relevant property characteristics.</div>
                    <div class="f4 text-bold text-center">Gross Rent Multiplier</div>
                    <div>Gross rent multiplier is the ratio of the price of a real estate investment to its annual rental income before accounting for expenses such as property taxes, insurance, and utilities; GRM is the number of years the property would take to pay for itself in gross received rent.</div>
                </div>
            </mvtDialog>

            <mvtDialog ref="dppAvmDisclaimer4" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                     <div class="dialog-profile">
                        <div class="circle huge default"><img loading="lazy" :src=" glb.cdnUrl + 'vimages/avm-img.svg'"/></div>
                    </div>
                    <div class="f4 text-bold text-center">Gross Rent Multiplier</div>
                    <div>Gross rent multiplier is the ratio of the price of a real estate investment to its annual rental income before accounting for expenses such as property taxes, insurance, and utilities; GRM is the number of years the property would take to pay for itself in gross received rent.</div>
                </div>
            </mvtDialog>

            <mvtDialog ref="dppHotPop" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                    <div class="f4 text-bold lh-small" v-html="popHotPanelTitle"></div>
                    <div v-html="popHotPanelContent"></div>
                </div>
            </mvtDialog>
            <mvtPopOwnup ref="popOwnup"
                :address="dpp.geo.address"
                :city="dpp.geo.city"
                :zipcode="dpp.geo.zipcode"
                :state="dpp.geo.state"
                :county="dpp.geo.county"
                :propertyType="ownUpPropertyType"
                :purchasePrice="dpp.price"
            ></mvtPopOwnup>
        </template>

        <PrimaryImageSchema/>
        <ApplicationSchema />
        <VirtualTourSchema />
        <DataFeedItemSchema />
        <mvtDialogCenter></mvtDialogCenter>
        <mvtToastCenter />
    </div>
</template>

<script src="./page-dpp-origin.js"></script>

<style lang="scss">
@use "./page-dpp-origin.scss" as *;
</style>
